module.exports = __webpack_public_path__ + "logo.9566536d2922457536e1.svg";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/img/logo.svg
// module id = ../../../../../src-admin/assets/img/logo.svg
// module chunks = main